import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss';
import { BrowserRouter as Router } from 'react-router-dom';

import Api from './_context/Api';

import 'minireset.css';
import Cursor from './_context/Cursor';
import InternalLinks from './_context/InternalLinks';
import Pages from './_context/Pages';
import Responsive from './_context/Responsive';
import TransitionedContainer, { TransitionedContainerReactContext } from './_context/TransitionedContainer';
import Burger from './components/Burger';
import Loading from './components/Loading';
import Logo from './components/Logo';
import Menu from './components/Menu';
import PageScrollContainer from './components/PageScrollContainer';
import TransitionedRoute from './components/TransitionedRoute';
import responsive from './constants/responsive';
import spacing from './constants/spacing';
import stylesheet from './constants/stylesheet';

export type AppProps = {};

const styles = {
  '@global': {
    'html, body': {
      position: 'relative',
      width: '100%',
      height: '100%',
      ...stylesheet.Body
    },
    'a': {
      textDecoration: 'none',
      color: 'inherit',
      cursor: 'pointer',
      "&:hover": {
        color: 'black'
      }
    },
    '#root': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      top: 0,
      left: 0,
      background: 'white'
    },
    'html.no-cursor *': {
      cursor: 'none !important'
    },
    '.custom-style-text-black': {
      color: 'black'
    },
    '.custom-style-text-small': {
      ...stylesheet.SmallText
    }
  },
  detail: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: '100vw'
  },
  pages: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '100vw',
    width: '100vw',
    overflow: 'hidden',
    [responsive.Mobile]: {
      pointerEvents: 'none',
      zIndex: 2,
      transition: 'transform 0.4s ease',
      backgroundColor: '#FFF',
      '*[data-position="menu"] &, *[data-position="pages"] &': {
        transform: 'translate3d(-100vw, 0, 0);'
      }
    },
    [responsive.Tablet]: {
    },
    [responsive.Laptop]: {
    },
    [responsive.Desktop]: {
    }
  },
  menus: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '50%',
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 9,
    [responsive.Mobile]: {
      width: spacing.MainLeftSideWidth.Mobile,
      padding: spacing.Gutter.Mobile,
      transition: 'transform 0.4s ease',
      '*[data-position="pages"] &, *[data-position="detail"] &': {
        transform: 'none'
      },
    },
    [responsive.Tablet]: {
      width: spacing.MainLeftSideWidth.Tablet,
      padding: `${spacing.Gutter.Tablet}px ${spacing.Gutter.Tablet / 2}px`
    },
    [responsive.Laptop]: {
      width: spacing.MainLeftSideWidth.Laptop,
      padding: `${spacing.Gutter.Laptop}px ${spacing.Gutter.Laptop / 2}px`
    },
    [responsive.Desktop]: {
      width: spacing.MainLeftSideWidth.Desktop,
      padding: `${spacing.Gutter.Desktop}px ${spacing.Gutter.Desktop / 2}px`
    }
  },
  menusInner: {
    [responsive.Mobile]: {
    },
    [responsive.Tablet]: {
      padding: `0 ${spacing.Gutter.Tablet / 2}px`
    },
    [responsive.Laptop]: {
      padding: `0 ${spacing.Gutter.Laptop / 2}px`
    },
    [responsive.Desktop]: {
      padding: `0 ${spacing.Gutter.Desktop / 2}px`
    }

  },

  contentInner: {
    // ...stylesheet.MarginGutter(.5, directions.left)
  },
  logoMobile: {
    position: 'absolute',
    left: '0',
    bottom: 0,
    [responsive.Mobile]: {
      // '*[data-position="pages"] &': {
      //   transform: 'translate3d(-100vw, 0, 0);'
      // }
    },
    [responsive.AfterTablet]: {
      display: 'none'
    }
  }
}

type Props = AppProps &
  StyledComponentProps<keyof typeof styles>;

class App extends React.Component<Props> {
  public render() {
    const { classes } = this.props;
    return (
      <Router>
        <InternalLinks domainnames={['novo-architectes.com', 'novo.ourcompany.ch']}>
          <Responsive mediaQueries={responsive}>
            <Api>
              <Cursor>
                <Loading />
                <Pages>
                  <TransitionedContainer>
                    <div className={classes!.detail}>
                      <TransitionedRoute types={['Home', 'Project']} direction='detail' />
                      <Burger />
                    </div>
                    <div className={classes!.pages}>
                      <div className={classes!.menus}>
                        <div className={classes!.menusInner}>
                          <Menu />
                          <div className={classes!.logoMobile}>
                            <TransitionedContainerReactContext.Consumer>
                              {(p) => <Logo transitionedContainer={p} />}
                            </TransitionedContainerReactContext.Consumer>
                          </div>
                        </div>
                      </div>
                      <PageScrollContainer types={['Projects', 'PanelPage']}>
                        <div className={classes!.contentInner}>
                          <TransitionedRoute types={['Projects', 'PanelPage']} direction='pages' />
                        </div>
                      </PageScrollContainer>
                    </div>
                  </TransitionedContainer>
                </Pages>
              </Cursor>
            </Api>
          </Responsive>
        </InternalLinks>
      </Router>
    );
  }
}

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.tsx